// extracted by mini-css-extract-plugin
export var container = "_mn-0";
export var dotAnimation = "_mn-2";
export var dotsLoading = "_mn-1";